import { render, staticRenderFns } from "./AttachedRole.vue?vue&type=template&id=2538af86"
import script from "./AttachedRole.vue?vue&type=script&lang=js"
export * from "./AttachedRole.vue?vue&type=script&lang=js"
import style0 from "./AttachedRole.vue?vue&type=style&index=0&id=2538af86&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports